import PuzzleTermList from './views/PuzzleTermList.vue';
import PuzzleTerm from './Root.vue';

export default {
  path: 'jogo/termo/',
  component: PuzzleTerm,
  name: 'admin-puzzle-term',
  redirect: '/jogo/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-puzzle-term-list',
      component: PuzzleTermList,
    },
  ],
};
